import styled, { css } from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

interface InstrumentsContainerProps {
	$subscription?: boolean;
}

export const InstrumentsContainer = styled.div<InstrumentsContainerProps>`
	display: flex;
	column-gap: 6px;
	margin-bottom: 24px;

	${(props) =>
		!props.$subscription &&
		css`
			justify-content: center;
			margin-bottom: 35px;
		`}
`;

interface InstrumentItemContainerProps {
	isActive: boolean;
}

export const InstrumentItemContainer = styled.div<InstrumentItemContainerProps>`
	display: flex;
	align-items: center;
	padding: 12px 20px 13px;
	border-radius: 8px;
	border: 1px solid #989898;
	color: #989898;
	cursor: pointer;

	${fontMixins(18, 700)};

	svg {
		width: 27px;
		height: 30px;
		margin-right: 13px;

		path {
			stroke: #989898;
		}

		&#keys {
			path {
				&:nth-child(2),
				&:nth-child(4),
				&:nth-child(8),
				&:nth-child(10),
				&:nth-child(12) {
					fill: #989898;
				}
			}
		}
	}

	${(props) =>
		props.isActive &&
		css`
			color: #d89f5b;
			border-color: #d89f5b;
			background: ${COLORS.White};

			svg {
				path {
					stroke: #d89f5b;
				}

				&#keys {
					path {
						&:nth-child(2),
						&:nth-child(4),
						&:nth-child(8),
						&:nth-child(10),
						&:nth-child(12) {
							fill: #d89f5b;
						}
					}
				}
			}
		`}
`;
